<script lang="ts">
	//UI
	import Item from "./Item.svelte";
	import { OutlineButton, PlusIcon } from "@hitit/new_ui";
	//Utils
	import { createEventDispatcher } from "svelte";
	//Types
	import type { PostDTO } from "@hitit/api";
	//Props
	export let editmode: boolean;
	export let items: PostDTO[] = [];
	//Constants
	const dispatch = createEventDispatcher();
	//Variables
	//Functions
	function newItemClickHandler() {
		dispatch("NEW_ITEM");
	}
	//Do
</script>

<div class="container">
	{#if editmode}
		<div class="add-item">
			<OutlineButton
				noneBordercolor
				fitmode
				nonePadding
				on:click={newItemClickHandler}
			>
				<div class="inner">
					<div class="add-sign">
						<PlusIcon thin />
					</div>
				</div>
			</OutlineButton>
		</div>
	{/if}
	{#each items as item (item.id)}
		<Item
			on:ITEM_CLICK
			on:ITEM_DELETE
			editmode={editmode}
			id={item.id}
			title={item.title}
			documentState={item.documentState}
			createdDate={item.createdDate}
		/>
	{/each}
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		flex-direction: column;
		gap: 10px;
		width: 100%;
		.add-item {
			box-sizing: border-box;
			border: 1px solid #bcbfc3;
			border-radius: 5px;
			width: 100%;
			max-width: 100%;
			height: 78px;
			.inner {
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
			}
			.add-sign {
				width: 35px;
				height: 54px;
			}
		}
	}
	@include DesktopSize {
		.container {
			overflow-y: auto;
			padding-right: 5px;
			box-sizing: border-box;
			gap: 20px;
			&::-webkit-scrollbar {
				width: 2px;
			}
			&::-webkit-scrollbar-track {
				background-color: transparent;
			}

			&::-webkit-scrollbar-thumb {
				background-color: #bcbfc3;
			}
			.add-item {
				min-height: 100px;
			}
		}
	}
</style>
